import { render, staticRenderFns } from "./RecordsTableEditable.vue?vue&type=template&id=6cc948ad&scoped=true"
import script from "./RecordsTableEditable.vue?vue&type=script&lang=js"
export * from "./RecordsTableEditable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc948ad",
  null
  
)

export default component.exports